// extracted by mini-css-extract-plugin
export var infoRow = "_s2-2";
export var labelContainer = "_s2-0";
export var rightInfo = "_s2-1";